{
  "version": 1,
  "asset_id": "e1e1ad2f-61cd-450b-baf6-9e962d2a1a76",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e1e1ad2f-61cd-450b-baf6-9e962d2a1a76/hiatal-type-2-story-preparation-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e1e1ad2f-61cd-450b-baf6-9e962d2a1a76/hiatal-type-2-story-preparation-480.webp",
  "original_filename": "hiatal-type-2-story-preparation-480.webp",
  "size": 20148,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:54:58Z"
}
